<script>
  import EditView from '../partials/EditView.vue'
  import FormInput from '../form/form-input.vue'

  export default {
    components: {
      EditView,
      FormInput,
    },
    props: {
      id: {
        type: String,
        required: true
      }
    },
  }
</script>
<template>
  <edit-view
    :id="id"
    v-slot="slotProps"
    store="bundle"
    list-route="BundleList"
  >
    <form-input
      :store="slotProps.store"
      prop-name="name"
      class="col-3"
    />
  </edit-view>
</template>
